/* Form component to add crew items from a select 
   dropdown */
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";
import btnStyles from "../../styles/Button.module.css";
import Alert from "react-bootstrap/Alert";
import { Dropdown } from "react-bootstrap";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import toast from "react-hot-toast";
import CrewCallsPageAdd2 from "./callsheetSections2/CrewCallsPageAdd2";

const AddCrew2 = ({ id, setShow, dataDay, dataDate, crewList  }) => {
  const host = useHostName();
  const [errors, setErrors] = useState({});
  const [crewcalls, setCrewcalls] = useState({ results: [] });

  const [postData, setPostData] = useState({
    name: "",
    position: "",
    phone: "",
    email: "",
    call: "",
  });

  const {
    name,
    position,
    phone,
    email,
    call,
  } = postData;

  const setData = (crew) => {
    /* Function to set crew values automatically
         when a crew is selected from the dropdown */
    const name = crew.name || "";
    const position = crew.position || "";
    const phone = crew.phone || "";
    const email = crew.email || "";

    setPostData({
      name: name,
      position: position,
      phone: phone,
      email: email,
      call: "",
    });
  };
  
  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const clear = () => {
    /* Function to clear crew values */
    setPostData({
      name: "",
      position: "",
      phone: "",
      email: "",
      call: "",
    });
  };

  /* 222222222 NEEDS NEW URL REQUEST for crew not cast 2222222222222222222222222222222222
  function to fetch the Callsheet Crew data already added */ 
  const handleMount = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `castcallsnew/?day_id=${id}&is_second_unit=true`
        );
        console.log(data)
        setCrewcalls(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/castcallsnew/?day_id=${id}&is_second_unit=true`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        console.log(data)
        setCrewcalls(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    handleMount();
    // eslint-disable-next-line
  }, [id]);

  /* 222222222 NEEDS NEW URL REQUEST */
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate call
    if (!call) {
      toast.error("A Calltime Must be Added", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }

    const formData = new FormData();

    formData.append("day_id", id);
    formData.append("shoot_day", dataDay);
    formData.append("shoot_date", dataDate);
    formData.append("name", name);
    formData.append("position", position);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("call", call);
    formData.append("is_second_unit", "true");

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.post("castcallsnew/", formData);
        setPostData({
          name: "",
          position: "",
          phone: "",
          email: "",
          call: "",
        });
        setCrewcalls((prevCrew) => ({
          ...prevCrew,
          results: [data, ...prevCrew.results],
        }));
        toast.success(`Crew Added`);
      } else {
        const { data } = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/castcallsnew/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setPostData({
          name: "",
          position: "",
          phone: "",
          email: "",
          call: "",
        });
        setCrewcalls((prevCrew) => ({
          ...prevCrew,
          results: [data, ...prevCrew.results],
        }));
        toast.success(`Crew Added Successfully!`);
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const buttons = (
      <div className="mb-2 text-center">    
        <Button
          className={`${btnStyles.Button} ${btnStyles.Blue} px-4 px-md-5 mr-3`}
          onClick={clear}
        >
          Clear
        </Button>
        <Button className={`px-3 px-md-5 ml-3 ${btnStyles.Button} ${btnStyles.Blue}`} type="submit">
          Submit
        </Button>
      </div>
    );

  return (
    <div className={`mb-3 pb-4 ${styles.WhiteForm }`}>
    <div className={`mt-0 mb-2 text-center ${styles.SubTitle }`}>
      <span className={`float-right pt-1 ${styles.Close }`}
       onClick={() => setShow(false) } >Close</span> 
      <h5 className={`pl-5 mb-0 text-center py-1 ${styles.Bold }`} >
      ADD CREW</h5>
      </div> 
      <div className={`mb-3 ${styles.White }`}>
        <Form className="text-center" onSubmit={handleSubmit}>
        <p className={`${styles.SmallSize } mb-0 text-center d-none d-md-block`}
         style={{fontStyle: 'italic'}}>
        Add Crew members from the Select Crew Dropdown</p>
        {/* select */}
        <Row className="d-flex align-items-center">
        <Col xs={12}  md={2} className="px-0 mx-0 mt-4" >
          <Dropdown className={`${styles.AddCrew }`}>
          <Dropdown.Toggle variant="info" id="dropdown-basic" size="sm">
            Select Crew
          </Dropdown.Toggle>
          <Dropdown.Menu className={`pt-1 pl-2 ${styles.DropButt}`}>
          {crewList.length && (
                crewList.map((crew) => (
                  <Dropdown.Item onClick={() => setData(crew) } 
                  key={crew.id} >{crew.position} - {crew.name}</Dropdown.Item>
                ) )) }
          </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col xs={12} md={4} className="px-5 px-md-3 mx-0">
        <div className={`mt-4 px-md-3 mb-3 mb-md-0 ${styles.HRGold }`}>
        <p className={``}>
        {position}
        </p>
        </div>
        </Col>
        <Col xs={6} md={4} className="px-3 mx-0">
        <div className={`mt-4 px-md-5 ${styles.HRGold }`}>
        <p className={``}>
        {name}
        </p>
        </div>
        </Col>
        <Col xs={6} md={2} className="d-flex justify-content-center mx-0 px-3" >
          <Form.Group controlId="call" className={`${styles.Width2} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Call</Form.Label>
                <Form.Control 
                className={`${styles.Input}`} 
                type="text"
                name="call"
                value={call}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.call?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
        </Col>
        </Row>
        {/* buttons */}
        <Row>
          <Col className="text-center">
          <div className= {`mt-4 `} >{buttons}</div>
          </Col>
        </Row>
        </Form>
        {/* break */}
      <Row>
        <Col md={2} className="d-none d-md-block"></Col>
        <Col xs={12} md={8}>
        <hr className={`${styles.Break7 }`}/>
        </Col>
      </Row>
      {/* NEW crew ADDED */}
      <Row >
      <Col xs={12} >
      <p className={`text-center pt-2 mb-0 ${styles.BoldScene }`}>
      CREW ADDED
      </p>
      <p className={`${styles.SmallSize } mb-0 text-center d-none d-md-block`} style={{fontStyle: 'italic'}}>
        Edit previously added Crew here</p>
      </Col>
      </Row>
      <CrewCallsPageAdd2
      handleMount={handleMount}
      crewcalls={crewcalls}/>
      </div>
    </div>
  );
};

export default AddCrew2;
